import { useMemo } from 'react'
import * as yup from 'yup'
import i18n from 'i18next'

type UseFormDynamicValuesValidationSchema = {
  validationSchema: yup.ObjectSchema<Record<string, any>>
}

function createYupSchema(schemaShape: Record<string, any>, field: Field): Record<string, any> {
  const { id, isRequired, type } = field
  if (!isRequired) {
    return schemaShape
  }

  let validator
  
  if (type.toLowerCase() === 'number') {
    validator = yup.number()
  } else {
    validator = yup.string()
  }

  schemaShape[id] = validator.required(i18n.t('required-field'))
  return schemaShape
}

export const useFormDynamicValuesValidationSchema = (fields: Field[]): UseFormDynamicValuesValidationSchema => {
  const validationSchema = useMemo(() => {
    const schemaShape = fields.reduce(createYupSchema, {} as Record<string, any>)
    return yup.object().shape(schemaShape)
  }, [fields])

  return { validationSchema }
}
